<template>
  <span class="svg-icon-audio">
    <svg v-if="isSolid" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path :fill="color" d="M8.47155 3.7L16.3198 7.16C17.9974 7.88 18.949 8.92 18.998 10.09C19.0471 11.26 18.174 12.37 16.5455 13.23H16.5356L8.47155 17.29V20.5H10.75C11.16 20.5 11.5 20.84 11.5 21.25C11.5 21.66 11.16 22 10.75 22H4.75C4.34 22 4 21.66 4 21.25C4 20.84 4.34 20.5 4.75 20.5H7V2.75C7 2.34 7.33355 2 7.73578 2C8.138 2 8.47155 2.34 8.47155 2.75V3.7Z"/>
    </svg>
    <svg v-else :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
      <path :fill="color" fill-rule="evenodd" clip-rule="evenodd" d="M4.75 22H10.75C11.16 22 11.5 21.66 11.5 21.25C11.5 20.84 11.16 20.5 10.75 20.5H8.42838V17.3116C8.45748 17.3017 8.48627 17.2894 8.51438 17.2744L16.4276 13.4511C18.1321 12.5953 19.0463 11.4418 18.9987 10.2046C18.9701 9.49765 18.5702 8.15812 16.1895 7.17207L8.47629 3.91626C8.46043 3.90933 8.44446 3.90303 8.42838 3.89734V2.69767C8.42838 2.31628 8.10461 2 7.71419 2C7.32377 2 7 2.31628 7 2.69767V20.5H4.75C4.34 20.5 4 20.84 4 21.25C4 21.66 4.34 22 4.75 22ZM8.42838 5.41691V15.7615L15.7801 12.2139C16.9418 11.6279 17.5989 10.9209 17.5703 10.2604C17.5417 9.61858 16.8371 8.95812 15.6277 8.45579L8.42838 5.41691Z"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isSolid: { type: Boolean },
  }
}
</script>